import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import observerOptions from "./options";
import Wrapper from "./Wrapper";
import Placeholder from "./Placeholder";
import { HelpIcon } from "../Svg";
// import { useMatchBreakpoints } from "../../contexts";
var StyledImage = styled.img.withConfig({
    componentId: "sc-b40628f8-0"
})(_templateObject());
var Image = function(_param) {
    var src = _param.src, alt = _param.alt, width = _param.width, borderRadius = _param.borderRadius, errorIcon = _param.errorIcon, height = _param.height, _isNft = _param.isNft, isNft = _isNft === void 0 ? false : _isNft, props = _object_without_properties(_param, [
        "src",
        "alt",
        "width",
        "borderRadius",
        "errorIcon",
        "height",
        "isNft"
    ]);
    var imgRef = useRef(null);
    // const { isMobile } = useMatchBreakpoints();
    var ref = useState(false), isLoaded = ref[0], setIsLoaded = ref[1];
    // const [neededSrc, setNeededSrc] = useState(src);
    // const [isError, setError] = useState(false);
    // const onError = () => {
    //   console.log("error image", src)
    //   setError(true);
    // };
    useEffect(function() {
        var observer;
        var isSupported = "object" === "object" && window.IntersectionObserver;
        if (imgRef.current && isSupported) {
            observer = new window.IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    var isIntersecting = entry.isIntersecting;
                    if (isIntersecting) {
                        setIsLoaded(true);
                        if (typeof (observer === null || observer === void 0 ? void 0 : observer.disconnect) === "function") {
                            observer.disconnect();
                        }
                    }
                });
            }, observerOptions);
            observer.observe(imgRef.current);
        }
        return function() {
            if (typeof (observer === null || observer === void 0 ? void 0 : observer.disconnect) === "function") {
                observer.disconnect();
            }
        };
    }, [
        src
    ]);
    // let content = <StyledImage style={{ borderRadius }} src={src} alt={alt} />;
    // if (!isLoaded) {
    //   // content = <AutoRenewIcon spin width={30} />
    // } else if (errorIcon) {
    //   // if (hiddenOnError) {
    //   //   return null;
    //   // }
    //   content = errorIcon ?? (
    //     <Placeholder>
    //       <HelpIcon width="30px" />
    //     </Placeholder>
    //   );
    // }
    return /*#__PURE__*/ _jsx(Wrapper, _object_spread_props(_object_spread({
        ref: imgRef,
        height: height,
        width: width
    }, props), {
        children: isLoaded ? /*#__PURE__*/ _jsx(StyledImage, {
            style: {
                borderRadius: borderRadius
            },
            src: src,
            alt: alt
        }) : /*#__PURE__*/ _jsx(Placeholder, {
            children: !isNft && /*#__PURE__*/ _jsx(HelpIcon, {
                width: "30px"
            })
        })
    }));
};
export default Image;
